import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/apartments.js'), 'apartments.js')
  resolveStoreModules(require('../store/carRental.js'), 'carRental.js')
  resolveStoreModules(require('../store/flight.js'), 'flight.js')
  resolveStoreModules(require('../store/general.js'), 'general.js')
  resolveStoreModules(require('../store/hotel.js'), 'hotel.js')
  resolveStoreModules(require('../store/news.js'), 'news.js')
  resolveStoreModules(require('../store/program.js'), 'program.js')
  resolveStoreModules(require('../store/round-trip.js'), 'round-trip.js')
  resolveStoreModules(require('../store/statistics.js'), 'statistics.js')
  resolveStoreModules(require('../store/thematic-offers.js'), 'thematic-offers.js')
  resolveStoreModules(require('../store/travel-assistant.js'), 'travel-assistant.js')
  resolveStoreModules(require('../store/user.js'), 'user.js')
  resolveStoreModules(require('../store/apartments/actions.js'), 'apartments/actions.js')
  resolveStoreModules(require('../store/apartments/getters.js'), 'apartments/getters.js')
  resolveStoreModules(require('../store/apartments/initial.js'), 'apartments/initial.js')
  resolveStoreModules(require('../store/apartments/mutations.js'), 'apartments/mutations.js')
  resolveStoreModules(require('../store/car-rental/actions.js'), 'car-rental/actions.js')
  resolveStoreModules(require('../store/car-rental/getters.js'), 'car-rental/getters.js')
  resolveStoreModules(require('../store/car-rental/initial.js'), 'car-rental/initial.js')
  resolveStoreModules(require('../store/car-rental/mutations.js'), 'car-rental/mutations.js')
  resolveStoreModules(require('../store/discount-pass/actions.js'), 'discount-pass/actions.js')
  resolveStoreModules(require('../store/discount-pass/getters.js'), 'discount-pass/getters.js')
  resolveStoreModules(require('../store/discount-pass/initial.js'), 'discount-pass/initial.js')
  resolveStoreModules(require('../store/discount-pass/mutations.js'), 'discount-pass/mutations.js')
  resolveStoreModules(require('../store/exclusive-offers/actions.js'), 'exclusive-offers/actions.js')
  resolveStoreModules(require('../store/exclusive-offers/getters.js'), 'exclusive-offers/getters.js')
  resolveStoreModules(require('../store/exclusive-offers/initial.js'), 'exclusive-offers/initial.js')
  resolveStoreModules(require('../store/exclusive-offers/mutations.js'), 'exclusive-offers/mutations.js')
  resolveStoreModules(require('../store/flight/actions.js'), 'flight/actions.js')
  resolveStoreModules(require('../store/flight/getters.js'), 'flight/getters.js')
  resolveStoreModules(require('../store/flight/initial.js'), 'flight/initial.js')
  resolveStoreModules(require('../store/flight/mutations.js'), 'flight/mutations.js')
  resolveStoreModules(require('../store/general/actions.js'), 'general/actions.js')
  resolveStoreModules(require('../store/general/getters.js'), 'general/getters.js')
  resolveStoreModules(require('../store/general/initial.js'), 'general/initial.js')
  resolveStoreModules(require('../store/general/mutations.js'), 'general/mutations.js')
  resolveStoreModules(require('../store/hotel/actions.js'), 'hotel/actions.js')
  resolveStoreModules(require('../store/hotel/getters.js'), 'hotel/getters.js')
  resolveStoreModules(require('../store/hotel/initial.js'), 'hotel/initial.js')
  resolveStoreModules(require('../store/hotel/mutations.js'), 'hotel/mutations.js')
  resolveStoreModules(require('../store/news/actions.js'), 'news/actions.js')
  resolveStoreModules(require('../store/news/getters.js'), 'news/getters.js')
  resolveStoreModules(require('../store/news/initial.js'), 'news/initial.js')
  resolveStoreModules(require('../store/news/mutations.js'), 'news/mutations.js')
  resolveStoreModules(require('../store/notifications/actions.js'), 'notifications/actions.js')
  resolveStoreModules(require('../store/notifications/getters.js'), 'notifications/getters.js')
  resolveStoreModules(require('../store/notifications/initial.js'), 'notifications/initial.js')
  resolveStoreModules(require('../store/notifications/mutations.js'), 'notifications/mutations.js')
  resolveStoreModules(require('../store/program/actions.js'), 'program/actions.js')
  resolveStoreModules(require('../store/program/getters.js'), 'program/getters.js')
  resolveStoreModules(require('../store/program/initial.js'), 'program/initial.js')
  resolveStoreModules(require('../store/program/mutations.js'), 'program/mutations.js')
  resolveStoreModules(require('../store/round-trip/actions.js'), 'round-trip/actions.js')
  resolveStoreModules(require('../store/round-trip/getters.js'), 'round-trip/getters.js')
  resolveStoreModules(require('../store/round-trip/initial.js'), 'round-trip/initial.js')
  resolveStoreModules(require('../store/round-trip/mutations.js'), 'round-trip/mutations.js')
  resolveStoreModules(require('../store/statistics/actions.js'), 'statistics/actions.js')
  resolveStoreModules(require('../store/statistics/getters.js'), 'statistics/getters.js')
  resolveStoreModules(require('../store/statistics/initial.js'), 'statistics/initial.js')
  resolveStoreModules(require('../store/statistics/mutations.js'), 'statistics/mutations.js')
  resolveStoreModules(require('../store/thematic-offers/actions.js'), 'thematic-offers/actions.js')
  resolveStoreModules(require('../store/thematic-offers/getters.js'), 'thematic-offers/getters.js')
  resolveStoreModules(require('../store/thematic-offers/initial.js'), 'thematic-offers/initial.js')
  resolveStoreModules(require('../store/thematic-offers/mutations.js'), 'thematic-offers/mutations.js')
  resolveStoreModules(require('../store/travel-assistant/actions.js'), 'travel-assistant/actions.js')
  resolveStoreModules(require('../store/travel-assistant/getters.js'), 'travel-assistant/getters.js')
  resolveStoreModules(require('../store/travel-assistant/initial.js'), 'travel-assistant/initial.js')
  resolveStoreModules(require('../store/travel-assistant/mutations.js'), 'travel-assistant/mutations.js')
  resolveStoreModules(require('../store/user/actions.js'), 'user/actions.js')
  resolveStoreModules(require('../store/user/getters.js'), 'user/getters.js')
  resolveStoreModules(require('../store/user/initial.js'), 'user/initial.js')
  resolveStoreModules(require('../store/user/mutations.js'), 'user/mutations.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
